<template>
  <pl-dialog
    :title="'Content Concierge'"
    :size="'xl'"
    :disableOutsideClick="true"
    @close="$emit('close')"
  >
    <body class="px-7 overflow-auto">
      <div class="my-7 flex justify-center font-semibold text-base">
        Fill out this form and our team can create a custom topic just for you.
        We'll reach out if we have any questions.
      </div>
      <div id="hubspotForm" v-once></div>
    </body>
  </pl-dialog>
</template>
<script>
  export default {
    mounted() {
      const script = document.createElement('script');
      script.charset = 'utf-8';
      script.type = 'text/javascript';
      script.src = '//js.hsforms.net/forms/v2.js';
      (document.body || document.head).appendChild(script);
      script.addEventListener('load', () => {
        if (window.hbspt) {
          window.hbspt.forms.create({
            region: 'na1',
            portalId: '2529635',
            formId: 'da642897-b5f6-4221-a09b-b381c321d452',
            target: '#hubspotForm',
          });
        }
      });
    },
  };
</script>



// WEBPACK FOOTER //
// contentConciergeModal.vue?0028bb5c